import { Component, OnDestroy, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { GlobalService } from "src/app/services/global/global.service";
import { USERStoreService } from "src/app/services/user/user-store.service";

@Component({
	selector: "app-password-changed",
	templateUrl: "./password-changed.component.html",
	styleUrls: ["./password-changed.component.css"]
})
export class PasswordChangedComponent implements OnInit, OnDestroy {
	constructor(
		public router: Router,
		public globalService: GlobalService,
		public userStoreService: USERStoreService
	) {}

	ngOnInit() {}
	ngOnDestroy() {
		this.userStoreService.outComeText = "";
	}
	public continue() {
		if (this.globalService.passwordChangeByLogIn) {
			const url = this.globalService.userActionCallFrom.replace("/", "");
			this.router.navigate([url], { skipLocationChange: true });
		} else {
			this.router.navigate(["contact-info"], { skipLocationChange: true });
		}
	}
}
